"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Container_1 = __importDefault(require("@mui/material/Container"));
const themes_1 = require("../../../themes");
exports.default = ({ children, sx }) => (react_1.default.createElement(Container_1.default, { sx: Object.assign({ maxWidth: { xl: '1368px', lg: '1200px' }, paddingX: {
            xs: themes_1.Spacings.small3,
            sm: themes_1.Spacings.small4,
            md: themes_1.Spacings.medium2,
        } }, (sx || {})) }, children));
